// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-summary-header {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 100%;
  padding-top: 24px;
  background-color: var(--surface-primary);
}

.fund-summary-header__top {
  display: flex;
  gap: 8px;
  width: 100%;
  flex-direction: column;
}

.fund-summary-header__name {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  gap: 8px;
  align-items: start;
  font-weight: 400;
  letter-spacing: -0.4px;
}

.fund-summary-header__ticker {
  flex-shrink: 0;
  color: var(--text-instrument);
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
}

.fund-summary-header__ticker[role='button'] {
  cursor: auto;
}

.fund-summary-header__instrument {
  flex-shrink: 1;
  min-width: 0;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-instrument);
  font-size: 20px;
  line-height: 24px;
}

.fund-summary-header__desc {
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  min-width: 0;
  gap: 8px;
  align-items: center;
}

.fund-summary-header__desc-item {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
  align-items: center;
}

.fund-summary-header__icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: var(--text-label);
}

.fund-summary-header__desc-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;
  color: var(--text-label);
}

.fund-summary-header__prices {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 100%;
}

.fund-summary-header__price-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: baseline;
  width: 100%;
}

.fund-summary-header__price {
  flex-shrink: 0;
  margin: 0;
  color: var(--text-primary);
  letter-spacing: -0.4px;
  white-space: nowrap;
}

.fund-summary-header__price-label {
  font-weight: 400;
  font-size: 12px;
  line-height: 29px;
}

.fund-summary-header__price-value {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
}

.fund-summary-header__price-currency {
  font-weight: 400;
  font-size: 12px;
  line-height: 29px;
}

.fund-summary-header__change {
  flex-shrink: 0;
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.4px;
  white-space: nowrap;
}

.fund-summary-header__change-symbol {
  font-size: 14px;
}

.fund-summary-header__change--up {
  color: var(--text-up-color);
}

.fund-summary-header__change--down {
  color: var(--text-down-color);
}

.fund-summary-header__change--unchg {
  color: var(--text-unchg-color);
}

.fund-summary-header__date {
  flex: 0 1 auto;
  min-width: fit-content;
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  white-space: nowrap;
  color: var(--text-secondary);
}

@container (min-width: 768px) {
  .fund-summary-header__desc {
    justify-content: flex-end;
  }
  .fund-summary-header__top {
    flex-direction: row;
  }
  .fund-summary-header__date {
    font-size: 16px;
  }
  .fund-summary-header__change {
    font-size: 20px;
  }
  .fund-summary-header__price-value {
    font-size: 24px;
  }
  .fund-summary-header__price-label {
    font-size: 14px;
  }
  .fund-summary-header__desc-text {
    font-size: 16px;
  }
  .fund-summary-header__name {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".fund-summary-header {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  width: 100%;\n  padding-top: 24px;\n  background-color: var(--surface-primary);\n}\n\n.fund-summary-header__top {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  flex-direction: column;\n}\n\n.fund-summary-header__name {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n  gap: 8px;\n  align-items: start;\n  font-weight: 400;\n  letter-spacing: -0.4px;\n}\n\n.fund-summary-header__ticker {\n  flex-shrink: 0;\n  color: var(--text-instrument);\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.fund-summary-header__ticker[role='button'] {\n  cursor: auto;\n}\n\n.fund-summary-header__instrument {\n  flex-shrink: 1;\n  min-width: 0;\n  align-self: stretch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--text-instrument);\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.fund-summary-header__desc {\n  display: flex;\n  flex: 0 1 auto;\n  flex-wrap: wrap;\n  min-width: 0;\n  gap: 8px;\n  align-items: center;\n}\n\n.fund-summary-header__desc-item {\n  display: flex;\n  flex-shrink: 0;\n  gap: 4px;\n  align-items: center;\n}\n\n.fund-summary-header__icon {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  color: var(--text-label);\n}\n\n.fund-summary-header__desc-text {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  white-space: nowrap;\n  color: var(--text-label);\n}\n\n.fund-summary-header__prices {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.fund-summary-header__price-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: baseline;\n  width: 100%;\n}\n\n.fund-summary-header__price {\n  flex-shrink: 0;\n  margin: 0;\n  color: var(--text-primary);\n  letter-spacing: -0.4px;\n  white-space: nowrap;\n}\n\n.fund-summary-header__price-label {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 29px;\n}\n\n.fund-summary-header__price-value {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 29px;\n}\n\n.fund-summary-header__price-currency {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 29px;\n}\n\n.fund-summary-header__change {\n  flex-shrink: 0;\n  margin: 0;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  white-space: nowrap;\n}\n\n.fund-summary-header__change-symbol {\n  font-size: 14px;\n}\n\n.fund-summary-header__change--up {\n  color: var(--text-up-color);\n}\n\n.fund-summary-header__change--down {\n  color: var(--text-down-color);\n}\n\n.fund-summary-header__change--unchg {\n  color: var(--text-unchg-color);\n}\n\n.fund-summary-header__date {\n  flex: 0 1 auto;\n  min-width: fit-content;\n  margin: 0;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n  white-space: nowrap;\n  color: var(--text-secondary);\n}\n\n@container (min-width: 768px) {\n  .fund-summary-header__desc {\n    justify-content: flex-end;\n  }\n  .fund-summary-header__top {\n    flex-direction: row;\n  }\n  .fund-summary-header__date {\n    font-size: 16px;\n  }\n  .fund-summary-header__change {\n    font-size: 20px;\n  }\n  .fund-summary-header__price-value {\n    font-size: 24px;\n  }\n  .fund-summary-header__price-label {\n    font-size: 14px;\n  }\n  .fund-summary-header__desc-text {\n    font-size: 16px;\n  }\n  .fund-summary-header__name {\n    flex-direction: row;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
